import { createListElements } from './create-list-el';

export async function createTocChildren(data, callback) {
  const $tocEl = await new Promise((resolve, reject) => {
    let $children;
    try {
      $children = createListElements(data);
    } catch (err) {
      reject(err);
    }
    resolve($children);
  });
  return callback($tocEl);
}
